import { render } from "./productGraduatedPrices.vue?vue&type=template&id=4c41b6a2"
import script from "./productGraduatedPrices.vue?vue&type=script&lang=js"
export * from "./productGraduatedPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__